module.exports = __webpack_public_path__ + "static/media/BurgerMenu.c43ae558.svg";